import { CsgUtils } from "../CsgUtils";
import { ElementGeometry } from "./ElementGeometry";
export class WallSideDummy extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mHeight = 0;
        this.mWidth = 0;
        this.mDepth = 0;
    }
    getType() {
        return ("WallSideDummy");
    }
    setMesh(pMesh) {
        //
    }
    get width() {
        return (this.mWidth);
    }
    get depth() {
        return this.mDepth;
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = this.mWidth;
        tParams.height = this.mHeight;
        tParams.depth = 0;
        tParams.floorOffset = 0.0;
        return (tParams);
    }
    getparent() {
        return (this.mParent);
    }
    create2dGeometry(pParent) {
        this.createImagePlane(pParent);
    }
    create3dGeometry(pParent) {
        this.createImagePlane(pParent);
    }
    createImagePlane(pParent) {
        if (this.mRoomElement.wallSidePolygon == null)
            return (null);
        let tCSG = CSG.fromPolygons([this.mRoomElement.wallSidePolygon]);
        let tMeshes = CsgUtils.buildMeshes(tCSG, this.mScene);
        if (tMeshes != null) {
            for (let tMesh of tMeshes) {
                tMesh.name = "room:wallSideDummy";
                tMesh.parent = pParent;
                tMesh.visibility = 0;
                tMesh.isPickable = false;
            }
            return (tMeshes[0]);
        }
        return (null);
    }
}
